import { render, staticRenderFns } from "./SearchResultsGrid.vue?vue&type=template&id=12940461&scoped=true"
import script from "./SearchResultsGrid.vue?vue&type=script&lang=js"
export * from "./SearchResultsGrid.vue?vue&type=script&lang=js"
import style0 from "./SearchResultsGrid.vue?vue&type=style&index=0&id=12940461&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12940461",
  null
  
)

export default component.exports